import type { DeepRequired } from '../fixtures.types'

const newFee: DeepRequired<NewFee> = {
  __typename: 'NewFee',
  fee_type: 'INVALID_FEE_TYPE',
  value: '',
}

export default newFee
